import { React, useState, useEffect } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  GroupTitle,
  DownArrowDraw,
  DropDownSearchDraw
} from "../../styledElements";
import 'antd/dist/antd.css';
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Checkbox,
  Upload,
  message
} from "antd";
import { HaberForm } from "../../styledElements";
import { StyledTab } from "../../pageStyled";
import { DatePicker } from "antd";
import { DatePickerY, GlobalSet, DisabledStyles } from "../../pageStyled";
import moment from "moment";
import warning from "../../../Assets/Icons/warning.png";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import { ModalPopup } from "../../../Components/Modal/modal";
import { getCustomers } from "../../../Services/customerServices";
import { useNavigate, useLocation } from "react-router-dom";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import { Country, State } from "country-state-city";
import { poExists } from "../../../Services/orderServices";
import { capital_letter, toHandlePOName } from "../../../Utils/helper/helper";
import MultiDiaAddOrderDrawer from "../OrderDetailDrawer/multiDiaAddOrderDrawer";
import { newUploadOrders, uploadPODocuments } from "../../../Services/uploadServices";
import { getImageURL } from "../../../Services/deckleMatchServices";

const { Option } = Select;
const { Dragger } = Upload;
const AddNewPoData = (props) => {
  const [cities, setCities] = useState([]);
  const [checkedBox, setCheckedBox] = useState(false);
  const [deliConsgineeCheckedBox, setConsigneeDeliAddCheckedBox] = useState(false);
  const [isVisibleCancelModal, setIsVisibleCancelModal] = useState(false);
  const [poDate, setDate] = useState(moment().format("DD/MM/YYYY"));
  const [customer, setCustomer] = useState("");
  const [consignee, setConsignee] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [form] = Form.useForm();
  const [po, setPo] = useState();
  const history = useNavigate();
  const poFromOrders = useLocation();

  const [visibleToaster, setVisibleToaster] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [isCustomerDropdownOpen, setCustomerDropdown] = useState(false);
  const [isConsigneeDropdownOpen, setConsigneeDropdown] = useState(false);
  const [isCountryDropdownOpen, setCountryDropdown] = useState(false);
  const [isStateDropdownOpen, setStateDropdown] = useState(false);
  const [isShippingCountryDropdownOpen, setShippingCountryDropdown] = useState(false);
  const [isShippingStateDropdownOpen, setShippingStateDropdown] = useState(false);
  const [shippedCustAddCheckbox, setshippedCustAddCheckbox] = useState(false);
  const [shippedConsigneeAddCheckbox, setShippedConsigneeAddCheckedBox] = useState(false);
  const [billingCustAddCheckbox, setBillingCustAddCheckbox] = useState(false);
  const [billingConsigneeAddCheckbox, setBillingConsigneeAddCheckedBox] = useState(false);
  const [isBillingCountryDropdownOpen, setBillingCountryDropdown] = useState(false);
  const [isBillingStateDropdownOpen, setBillingStateDropdown] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [newOrderDrawer, setNewOrderDrawer] = useState(false);
  const [rendering, setRendering] = useState(true);
  const [poData, setPoData] = useState();
  const [billingCities,setBillingCities] = useState([]);
  const [shippingCities,setShippingCities] = useState([]);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [uploadedFileErr, setFileErr] = useState([]);

  const fileUploadData = {
    name: 'file',
    multiple: false,
    maxCount: 5,
    listType: 'picture',
    accept: 'image/jpg, image/jpeg, .pdf',
    beforeUpload: () => {
        return false
    },
    // action: ' http://localhost:3000/api/upload_file',
    onChange(info) {
      const { status } = info.file;
      if (status === 'removed'){
        let uploadedFileArr = [...uploadedFile];
        let removedFile = uploadedFileArr.filter((d) => d.uid !== info.file.uid);
        setUploadedFile((prevState) => prevState.filter((d) => d.uid !== info.file.uid));
        if(!removedFile?.length){
          setFileErr([]);
        } else{
          let prevErr = [...uploadedFileErr];
          let errArr = [];
          if(prevErr?.length){
            prevErr.map((ele) => {
              if(ele.key !== info.file.uid){
                errArr.push(ele);
              }
            });            
            setFileErr(errArr);
          } else{
            setFileErr([]);
          }
        }
      } else {
        let arr = [];
        info.fileList.map((item) => {
          arr.push(item["originFileObj"]);
        });
        setUploadedFile(arr);
        let fileSize = (info.file.size / 1024 / 1024)?.toFixed(2);
        let errArr = [];
        let prevErr = [...uploadedFileErr];
        if((fileSize > 1) || (info.file.type != "application/pdf" && info.file.type != "image/jpeg" && info.file.type != "image/jpg")){
          let errObj = {};
          errArr.push(...prevErr);
          errObj["key"] = info.file.uid;
          errObj["err"] = true;
          errObj["name"] = info.file.name;
          errArr.push(errObj);
          setFileErr(errArr);
        } else{
          errArr.push(...prevErr);
          setFileErr(errArr);
        }
      }
    },
    onDrop(e) {
        console.log('Dropped files', e.dataTransfer.files);
        setUploadedFile((prevState) => prevState.filter((d) => d.uid !== e.dataTransfer.files.uid));
    },
  };

  const OntoggleSelect =()=>{
    setCustomerDropdown((prevState) => !prevState
  )
  }

  const onToggleSelectForConsginee = () => {
    setConsigneeDropdown((prevState) => !prevState
  )
  }
  
  const routeBack = () => {
    history("../order-records");
  };

  const clearAddControls = () => {
    form.setFieldsValue({delivery_address_line_1:""});
    form.setFieldsValue({delivery_address_line_2:""});
    form.setFieldsValue({country:""});
    form.setFieldsValue({state:""});
    form.setFieldsValue({City:""});
    form.setFieldsValue({pincode:""});
  }

  //Cancel Changes modal
  const modalCancelShow = () => {
    setIsVisibleCancelModal(true);
  };
  const modalCancelClose = () => {
    setIsVisibleCancelModal(false);
  };
  const modalCancelConfirm = () => {
    routeBack();
    setIsVisibleCancelModal(false);
    form.resetFields();
  };

  const onChangeHandlerBox = (e) => {
    setCheckedBox(e.target.checked);
    if (e.target.checked){
      setConsigneeDeliAddCheckedBox(false);
      setCustomerAddress(customer, "delivery");
    } else{
      clearAddControls();
    }
};

  const deliveryAddConsigneeHandler = (e) => {
    setConsigneeDeliAddCheckedBox(e.target.checked);
    if(e.target.checked){
      setCheckedBox(false);
      setCustomerAddress(consignee, "delivery");
    } else{
      clearAddControls();
    }
  }

  const handleProvinceChange = (value) => {
    setCities(State.getStatesOfCountry(value));
    form.setFieldsValue({ state: State.getStatesOfCountry(value)[0]?.name });
  };
  const handleProvinceChangeForShipping = (value) => {
    setShippingCities(State.getStatesOfCountry(value));
    form.setFieldsValue({ shipping_state: State.getStatesOfCountry(value)[0]?.name });
  };
  const handleProvinceChangeForBilling = (value) => {
    setBillingCities(State.getStatesOfCountry(value));
    form.setFieldsValue({ billing_state: State.getStatesOfCountry(value)[0]?.name });
  };

  const poHandler = (e) => {
    setPo((e.target.value).toUpperCase());
  };

  const dateHandler = (e) => {
    const testDate = new Date(e._d);
    setDate(moment(testDate).format("DD/MM/YYYY"));
  };

  const customerHandler = (e) => {
    setCustomer(e);
    setBillingCustAddCheckbox(true);
    setBillingConsigneeAddCheckedBox(false);
    setCustomerAddress(e, "billing");
    if(form.getFieldValue('consignee') === '' || form.getFieldValue('consignee') === undefined)
    {
      form.setFieldsValue({consignee : e})
      consigneeHandler(e);
    }
  };

  const consigneeHandler = (e) => {
    setConsignee(e);
    setConsigneeDeliAddCheckedBox(true);
    setCheckedBox(false);
    setShippedConsigneeAddCheckedBox(true);
    setshippedCustAddCheckbox(false);
    setCustomerAddress(e, "delivery");
    setCustomerAddress(e, "shipping");
  };

  const routeChange = () => {
    form.submit();
  };

  const handleAddNewOrder = () => {
    form.submit();
    // setIsButtonClicked(true);
  };

  const showAddNewOrder = () => {
    setNewOrderDrawer(true);
  };

  const onCloseAddNewOrder = () => {
    setNewOrderDrawer(false);
  };

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 3000);
  };

  const setCustomerAddress = (key, addressStatus) => {
    const fields = form.getFieldsValue();
    const currentCustomerDetails = customerList.filter((cust) => {
        return cust.code === key;
      });
    if(currentCustomerDetails?.length){
      if(addressStatus === "delivery"){
        let newObj = {
          ...fields,
          delivery_address_line_1:
            currentCustomerDetails[0]?.delivery_address_line_1,
          delivery_address_line_2:
            currentCustomerDetails[0]?.delivery_address_line_2,
          country: currentCustomerDetails[0]?.delivery_country,
          City: currentCustomerDetails[0]?.delivery_city,
          state: currentCustomerDetails[0]?.delivery_state,
          pincode: currentCustomerDetails[0]?.delivery_pincode,
        };
        form.setFieldsValue(newObj);
      } else if(addressStatus === "shipping"){
        let newObj = {
          ...fields,
          shipping_address_line_1:
            currentCustomerDetails[0]?.delivery_address_line_1,
          shipping_address_line_2:
            currentCustomerDetails[0]?.delivery_address_line_2,
          shipping_country: currentCustomerDetails[0]?.delivery_country,
          shipping_city: currentCustomerDetails[0]?.delivery_city,
          shipping_state: currentCustomerDetails[0]?.delivery_state,
          shipping_pincode: currentCustomerDetails[0]?.delivery_pincode,
        };
        form.setFieldsValue(newObj);
      } else{
        let newObj = {
          ...fields,
            billing_address_line_1:
            currentCustomerDetails[0]?.address_line_1,
            billing_address_line_2:
            currentCustomerDetails[0]?.address_line_2,
            billing_country: currentCustomerDetails[0]?.country,
            billing_city: currentCustomerDetails[0]?.city,
            billing_state: currentCustomerDetails[0]?.state,
            billing_pincode: currentCustomerDetails[0]?.pincode,
        };
        form.setFieldsValue(newObj);
      }
    }
  };

  const onFinish = async (values) => {
    // Checking the existence of po number entered
    await poExists(po)
      .then((response) => {
        console.log("existed:", po);
        setActionToaster({
          error: !response.error,
          msg: `PO ${po} already exists`,
        });
        showToaster();
      })
      .catch(async (error) => {
        // if(uploadedFileErr?.length){
          let uplodedDocsArr = [];
          for(let i = 0; i < uploadedFile.length; i++){
            uplodedDocsArr.push(po + "/" + uploadedFile[i]["name"]);
            // await uploadPODocuments(po, uploadedFile[i]).then((response) => {
            //   console.log(response);
            // }).catch((err) => {
            //   console.log(err);
            // });
             // Step 1: Generate signed URL for upload
                  const res = await getImageURL({
                    bucket_key: `${values["poNumber"].toUpperCase()+'#%#'+values['customer']}/${uploadedFile[i]["name"]}`,
                    operation: "upload"
                  });
            
                  // Step 2: Upload file to that signed URL
                  const uploadResponse = res && await newUploadOrders(res, uploadedFile[i]);
          }
          values["poNumber"] = values["poNumber"].toUpperCase()+'#%#'+values['customer'];
          values["City"] = capital_letter(values["City"]);
          console.log("not existed:", po);
          if(isButtonClicked){
            let poValues = {
              ...values,
              date: poDate,
              checkedBox: checkedBox,
              deliConsgineeCheckedBox: deliConsgineeCheckedBox,
              shippedConsigneeAddCheckbox: shippedConsigneeAddCheckbox,
              shippedCustAddCheckbox:shippedCustAddCheckbox,
              billingCustAddCheckbox: billingCustAddCheckbox,
              billingConsigneeAddCheckbox: billingConsigneeAddCheckbox,
              address_type  : {
                billing_address : billingCustAddCheckbox ? 'customer' : billingConsigneeAddCheckbox ? 'consignee' : "",
                delivery_address : checkedBox ? 'customer' : deliConsgineeCheckedBox ? 'consignee' : "",
                shipping_address : shippedCustAddCheckbox ? 'customer' : shippedConsigneeAddCheckbox ? 'consignee' : "",
              },
              uplodedDocsArr : uplodedDocsArr
            }
            setPoData(poValues);
            showAddNewOrder();
          } else{
            history("../order-details", {
              state: { values: { ...values, 
                date: poDate,
                checkedBox: checkedBox,
                deliConsgineeCheckedBox: deliConsgineeCheckedBox,
                shippedConsigneeAddCheckbox: shippedConsigneeAddCheckbox,
                shippedCustAddCheckbox:shippedCustAddCheckbox,
                billingCustAddCheckbox: billingCustAddCheckbox,
                billingConsigneeAddCheckbox: billingConsigneeAddCheckbox,
                address_type  : {
                  billing_address : billingCustAddCheckbox ? 'customer' : billingConsigneeAddCheckbox ? 'consignee' : "",
                  delivery_address : checkedBox ? 'customer' : deliConsgineeCheckedBox ? 'consignee' : "",
                  shipping_address : shippedCustAddCheckbox ? 'customer' : shippedConsigneeAddCheckbox ? 'consignee' : "",
                },
                uplodedDocsArr : uplodedDocsArr
              }, route: "add-new-po" },
            });
          }
        // }
      });
  };

  const OnCountryToggleSelect =()=>{
    setCountryDropdown((prevState) => !prevState
  )
  };

  const OnStateToggleSelect =()=>{
    setStateDropdown((prevState) => !prevState
  )
  };

  const OnShippingCountryToggleSelect =()=>{
    setShippingCountryDropdown((prevState) => !prevState
  )
  };

  const OnShippingStateToggleSelect =()=>{
    setShippingStateDropdown((prevState) => !prevState
  )
  };

  const clearShippedAddControls = () => {
    form.setFieldsValue({shipping_address_line_1:""});
    form.setFieldsValue({shipping_address_line_2:""});
    form.setFieldsValue({shipping_country:""});
    form.setFieldsValue({shipping_state:""});
    form.setFieldsValue({shipping_city:""});
    form.setFieldsValue({shipping_pincode:""});
  };

  const shippedAddCustHandler = (e) => {
    setshippedCustAddCheckbox(e.target.checked);
    if(e.target.checked){
      setShippedConsigneeAddCheckedBox(false);
      setCustomerAddress(customer, "shipping");
    } else{
      clearShippedAddControls();
    }
  };

  const shippedAddConsigneeHandler = (e) => {
    setShippedConsigneeAddCheckedBox(e.target.checked);
    if(e.target.checked){
      setshippedCustAddCheckbox(false);
      setCustomerAddress(consignee, "shipping");
    } else{
      clearShippedAddControls();
    }
  }

  const OnBillingStateToggleSelect = () => {
    setBillingStateDropdown((prevState) => !prevState)
  };

  const OnBillingCountryToggleSelect =()=>{
    setBillingCountryDropdown((prevState) => !prevState
  )
  };

  const clearBiiledAddControls = () => {
    form.setFieldsValue({billing_address_line_1:""});
    form.setFieldsValue({billing_address_line_2:""});
    form.setFieldsValue({billing_country:""});
    form.setFieldsValue({billing_state:""});
    form.setFieldsValue({billing_city:""});
    form.setFieldsValue({billing_pincode:""});
  }

  const billingAddCustHandler = (e) => {
    setBillingCustAddCheckbox(e.target.checked);
    if(e.target.checked){
      setBillingConsigneeAddCheckedBox(false);
      setCustomerAddress(customer, "billing");
    } else{
      clearBiiledAddControls();
    }
  };

  const billingAddConsigneeHandler = (e) => {
    setBillingConsigneeAddCheckedBox(e.target.checked);
    if(e.target.checked){
      setBillingCustAddCheckbox(false);
      setCustomerAddress(consignee, "billing");
    } else{
      clearBiiledAddControls();
    }
  };

  // const onChangeFile = (e) => {
  //   // let uploadedFiles = [];
  //   // uploadedFiles = [...uploadedFile];
  //   // if(uploadedFiles.length){
  //   //   uploadedFiles?.map((ele, ind) => {
  //   //     if(ele?.uid != e.file.uid){
  //   //       uploadedFiles.push(e.file);
  //   //       setUploadedFile(uploadedFiles);
  //   //     }
  //   //   });
  //   // } else{
  //   //   uploadedFiles.push(e.file);
  //   //   setUploadedFile(uploadedFiles);
  //   // }     

  //   // let fileSize;
  //   // for(let i = 0; i < uploadedFiles.length; i++){
  //   //   fileSize = (uploadedFiles[i].size / 1024 / 1024)?.toFixed(2);
  //   //   console.log(uploadedFiles[i].uid);
  //   // }
  //   // if(fileSize > 1){
  //   //   setFileErr(true);
  //   // }

  //   if(deletedFile){
  //     let newArray = e.fileList.filter((item) => {
  //       return (item.uid != deletedFile.uid);
  //     });
  //     setUploadedFile(newArray);
  //   } else{
  //     setUploadedFile(e.fileList);
  //   }
  // };

  useEffect(() => {
    getCustomers({ status: "active" })
      .then((response) => {
        setCustomerList(response);
      })
      .catch((error) => {
        console.log(error);
      });
    // Setting the field values to default
    poFromOrders?.state?.isData &&
      form.setFieldsValue({
        poNumber: toHandlePOName(poFromOrders.state.values.poNumber),
        date: poFromOrders.state.values.date
          ? moment(poFromOrders.state.values.date, "DD/MM/YYYY")
          : null,
        customer: poFromOrders.state.values.customer,
        delivery_address_line_1:
          poFromOrders.state.values.delivery_address_line_1,
        delivery_address_line_2:
          poFromOrders.state.values.delivery_address_line_2,
        country: poFromOrders.state.values.country,
        state: poFromOrders.state.values.state,
        City: poFromOrders.state.values.City,
        pincode: poFromOrders.state.values.pincode,
        billing_address_line_1:poFromOrders.state.values.billing_address_line_1,
        billing_address_line_2:poFromOrders.state.values.billing_address_line_2,
        billing_city:poFromOrders.state.values.billing_city,
        billing_country:poFromOrders.state.values.billing_country,
        billing_pincode:poFromOrders.state.values.billing_pincode,
        billing_state:poFromOrders.state.values.billing_state,
        shipping_address_line_1:poFromOrders.state.values.shipping_address_line_1,
        shipping_address_line_2:poFromOrders.state.values.shipping_address_line_2,
        shipping_city:poFromOrders.state.values.shipping_city,
        shipping_country:poFromOrders.state.values.shipping_country,
        shipping_pincode:poFromOrders.state.values.shipping_pincode,
        shipping_state:poFromOrders.state.values.shipping_state,
        consignee: poFromOrders.state.values.consignee,
      });
      setCustomer(poFromOrders?.state?.values?.customer);
      setConsignee(poFromOrders?.state?.values?.consignee);
      setCheckedBox(poFromOrders?.state?.values?.checkedBox);
      setShippedConsigneeAddCheckedBox(poFromOrders?.state?.values?.shippedConsigneeAddCheckbox);
      setshippedCustAddCheckbox(poFromOrders?.state?.values?.shippedCustAddCheckbox);
      setConsigneeDeliAddCheckedBox(poFromOrders?.state?.values?.deliConsgineeCheckedBox);
      setBillingCustAddCheckbox(poFromOrders?.state?.values?.billingCustAddCheckbox);
      setBillingConsigneeAddCheckedBox(poFromOrders?.state?.values?.billingConsigneeAddCheckbox);
    poFromOrders.state?.isData && setPo(poFromOrders.state.values.poNumber);
  }, []);

  // useEffect(() => {
  //   if (checkedBox) {
  //     setCustomerAddress();
  //   }
  // }, [customer]);

  return (
    <RightLayoutContainer>
      <PageTitleComp
        className="marginRightAdg"
        style={{ marginBottom: "12px" }}
      >
        <PageHeader
          title="Add a new PO"
          extra={[
            <Button
              key="3"
              className="textTypeBtn"
              onClick={modalCancelShow}
              disabled={
                poFromOrders.state?.values &&
                poFromOrders.state?.cancelChangesDisable
              }
              style={{
                background: "transparent",
              }}
            >
              Cancel changes
            </Button>,
            <Button
              key="1"
              className="themeBtn"
              onClick={routeChange}
              disabled={uploadedFileErr?.length}
            >
              <Iconmoon icon="file-check" size={14} color="#ffffff" />
              Add Orders
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        {/* Infobar */}
        {/* <AlertContainer
          color="blue"
          icon={alertBlue}
          msg="The PO details can only be changed when there are no orders added in the PO. Please make sure you have entered right details in PO page before adding orders to it"
        /> */}

        {/* <HaberForm> */}
          {/* <StyledTab> */}
            <div className="groupDetailWrap">
              <Form
                id="form"
                form={form}
                name="basic"
                autoComplete="off"
                className="haberLogin"
                onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
              >
                <HaberForm>
                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>General Details</h2>
                        <p>
                          General details will be used to identify Purchase Order
                          in reports
                        </p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>PO Number</label>
                            <p>A unique number to identify the Purchase Order</p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <Form.Item
                              name="poNumber"
                              rules={[
                                {
                                  required: true,
                                  message: "PO number is required",
                                },
                                {
                                  max: 50,
                                  message:
                                    "PO number can have a maximum of 50 characters",
                                },
                              ]}
                              className=""
                            >
                              <Input
                                placeholder="Enter PO Number"
                                onChange={poHandler}
                                disabled={
                                  poFromOrders.state?.cancelChangesDisable
                                }
                                style={{ textTransform: "uppercase" }}
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>PO Date</label>
                            <p>Date when Purchase Order was received</p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <DatePickerY>
                              <Form.Item name="date">
                                <DatePicker
                                  defaultValue={moment()}
                                  format={"DD/MM/YYYY"}
                                  disabled={
                                    poFromOrders.state?.cancelChangesDisable
                                  }
                                  onChange={dateHandler}
                                  // value={moment()}
                                />
                              </Form.Item>
                            </DatePickerY>
                          </div>
                        </Col>
                      </Row>
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>Customer</label>
                            <p>
                              Name of the Customer/Dealer who issued <br />
                              the Purchase Order
                            </p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <Form.Item
                              name="customer"
                              rules={[
                                {
                                  required: true,
                                  message: "Customer is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                name="customer"
                                suffixIcon={
                                  isCustomerDropdownOpen ? (
                                    <DropDownSearchDraw />
                                  ) : (
                                    <DownArrowDraw />
                                  )
                                }
                                onBlur={OntoggleSelect}
                                onFocus={OntoggleSelect}
                                optionFilterProp="children"
                                onChange={customerHandler}
                                placeholder="Select Customer"
                                disabled={
                                  poFromOrders.state?.cancelChangesDisable
                                }
                                // filterOption={(input, option) =>
                                //   option.props.children
                                //     .toLowerCase()
                                //     .indexOf(input.toLowerCase()) >= 0 ||
                                //   option.props.value
                                //     .toLowerCase()
                                //     .indexOf(input.toLowerCase()) >= 0
                                // }
                              >
                                {customerList.map((cust) => (
                                  <Option key={cust.code}>
                                    {cust.code} - {cust.name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>Consignee</label>
                            <p>
                              Name of the Consignee responsible for this <br />
                              Purchase Order
                            </p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <Form.Item
                              name="consignee"
                              rules={[
                                {
                                  required: true,
                                  message: "Consignee is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                name="consignee"
                                suffixIcon={
                                  isConsigneeDropdownOpen ? (
                                    <DropDownSearchDraw />
                                  ) : (
                                    <DownArrowDraw />
                                  )
                                }
                                onBlur={onToggleSelectForConsginee}
                                onFocus={onToggleSelectForConsginee}
                                optionFilterProp="children"
                                onChange={consigneeHandler}
                                placeholder="Select Consignee"
                                disabled={
                                  poFromOrders.state?.cancelChangesDisable
                                }
                              >
                                {customerList.map((cust) => (
                                  <Option key={cust.code}>
                                    {cust.code} - {cust.name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>Delivery Address</h2>
                        <p>
                          The customer/dealer address where order is to be
                          delivered
                        </p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>Building Number and Street Address</label>
                            <p
                              style={{
                                fontSize: "14px",
                                lineHeight: "20px",
                                fontFamily: "var(--sf-pro-display-m)",
                                color: "var(--black-color)",
                                marginBottom: "5px",
                              }}
                            >
                              The complete postal address for delivery
                            </p>
                            <div className="checklist-address">
                              <Checkbox
                                type="checkbox"
                                value={checkedBox}
                                checked={checkedBox}
                                onChange={onChangeHandlerBox}
                                disabled={!customer}
                              >
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontStyle: "normal",
                                    lineHeight: "20px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--para-text)",
                                    margin: "0",
                                  }}
                                >
                                  This address is same as customer delivery address
                                </span>
                              </Checkbox>
                            </div>
                            <div className="checklist-address">
                              <Checkbox
                                type="checkbox"
                                value={deliConsgineeCheckedBox}
                                checked={deliConsgineeCheckedBox}
                                onChange={deliveryAddConsigneeHandler}
                                disabled={!consignee}
                              >
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontStyle: "normal",
                                    lineHeight: "20px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--para-text)",
                                    margin: "0",
                                  }}
                                >
                                  This address is same as consignee delivery address
                                </span>
                              </Checkbox>
                            </div>
                          </div>
                        </Col>

                        <Col span={12} className="blockBreak">
                          <div className="boxFormType">
                            {/* <GlobalSet>
                              <div className="checklist-address">
                                <Checkbox
                                  type="checkbox"
                                  value={checkedBox}
                                  onChange={onChangeHandlerBox}
                                  disabled={!customer}
                                />
                                <p>This address is same as customer address</p>
                              </div>
                            </GlobalSet> */}
                            <DisabledStyles>
                              <Form.Item
                                name="delivery_address_line_1"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                ]}
                                className=""
                              >
                                <Input
                                  disabled={
                                    checkedBox || deliConsgineeCheckedBox ||
                                    poFromOrders.state?.cancelChangesDisable
                                  }
                                  type="text"
                                  className="disabled-check"
                                  placeholder="First Line of address"
                                />
                              </Form.Item>
                            </DisabledStyles>
                          </div>

                          <div className="boxFormType">
                            <DisabledStyles>
                              <Form.Item
                                name="delivery_address_line_2"
                                rules={[{}]}
                                className=""
                              >
                                <Input
                                  disabled={
                                    checkedBox || deliConsgineeCheckedBox ||
                                    poFromOrders.state?.cancelChangesDisable
                                  }
                                  className="disabled-check"
                                  placeholder="Second Line of address"
                                />
                              </Form.Item>
                            </DisabledStyles>
                          </div>

                          <Col span={12} className="d-flex">
                            <div className="boxFormType">
                              <DisabledStyles>
                                <Form.Item
                                  name="country"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                  className=""
                                >
                                  <Select
                                    className="disabled-check"
                                    disabled={
                                      checkedBox || deliConsgineeCheckedBox ||
                                      poFromOrders.state?.cancelChangesDisable
                                    }
                                    suffixIcon={
                                      isCountryDropdownOpen ? (
                                        <DropDownSearchDraw />
                                      ) : (
                                        <DownArrowDraw />
                                      )
                                    }
                                    onChange={handleProvinceChange}
                                    onBlur={OnCountryToggleSelect}
                                    onFocus={OnCountryToggleSelect}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    placeholder="Select Country"
                                  >
                                    {Country.getAllCountries().map((province) => (
                                      <Option key={province.isoCode}>
                                        {province.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                            <div className="boxFormType">
                              <DisabledStyles>
                                <Form.Item
                                  name="state"
                                  className=""
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                >
                                  <Select
                                    disabled={
                                      checkedBox || deliConsgineeCheckedBox ||
                                      poFromOrders.state?.cancelChangesDisable
                                    }
                                    suffixIcon={
                                      isStateDropdownOpen ? (
                                        <DropDownSearchDraw />
                                      ) : (
                                        <DownArrowDraw />
                                      )
                                    }
                                    onBlur={OnStateToggleSelect}
                                    onFocus={OnStateToggleSelect}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    placeholder="Select State"
                                  >
                                    {cities.map((city) => (
                                      <Option key={city.name}>{city.name}</Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                          </Col>
                          <Col span={12} className="d-flex">
                            <div
                              className="boxFormType"
                              style={{ marginBottom: "0" }}
                            >
                              <DisabledStyles>
                                <Form.Item
                                  name="City"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                  className=""
                                >
                                  <Input
                                    placeholder="City"
                                    disabled={
                                      checkedBox || deliConsgineeCheckedBox ||
                                      poFromOrders.state?.cancelChangesDisable
                                    }
                                    className="disabled-check"
                                    style={{ textTransform: "capitalize" }}
                                  />
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                            <div className="boxFormType">
                              <DisabledStyles>
                                <Form.Item
                                  name="pincode"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                    { min: 6, message: "Minimum length: 6" },
                                    { max: 6, message: "Maximum length: 6" },
                                    {
                                      pattern: new RegExp(/^[0-9]+$/),
                                      message: "Only Numeric value is possible",
                                    },
                                  ]}
                                  className=""
                                >
                                  <Input
                                    disabled={
                                      checkedBox || deliConsgineeCheckedBox ||
                                      poFromOrders.state?.cancelChangesDisable
                                    }
                                    className="disabled-check"
                                    placeholder="ZIP code"
                                  />
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                          </Col>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>Shipping Address</h2>
                        <p>
                          The customer/dealer address where order is to be
                          shipped
                        </p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>Building Number and Street Address</label>
                            <p
                              style={{
                                fontSize: "14px",
                                lineHeight: "20px",
                                fontFamily: "var(--sf-pro-display-m)",
                                color: "var(--black-color)",
                                marginBottom: "5px",
                              }}
                            >
                              The complete postal address for shipping
                            </p>
                            <div className="checklist-address">
                              <Checkbox
                                type="checkbox"
                                value={shippedCustAddCheckbox}
                                checked={shippedCustAddCheckbox}
                                onChange={shippedAddCustHandler}
                                disabled={!customer}
                              >
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontStyle: "normal",
                                    lineHeight: "20px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--para-text)",
                                    margin: "0",
                                  }}
                                >
                                  This address is same as customer delivery address
                                </span>
                              </Checkbox>
                            </div>
                            <div className="checklist-address">
                              <Checkbox
                                type="checkbox"
                                value={shippedConsigneeAddCheckbox}
                                checked={shippedConsigneeAddCheckbox}
                                onChange={shippedAddConsigneeHandler}
                                disabled={!consignee}
                              >
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontStyle: "normal",
                                    lineHeight: "20px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--para-text)",
                                    margin: "0",
                                  }}
                                >
                                  This address is same as consignee delivery address
                                </span>
                              </Checkbox>
                            </div>
                          </div>
                        </Col>

                        <Col span={12} className="blockBreak">
                          <div className="boxFormType">
                            <DisabledStyles>
                              <Form.Item
                                name="shipping_address_line_1"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                ]}
                                className=""
                              >
                                <Input
                                  disabled={
                                    shippedCustAddCheckbox || shippedConsigneeAddCheckbox ||
                                    poFromOrders.state?.cancelChangesDisable
                                  }
                                  type="text"
                                  className="disabled-check"
                                  placeholder="First Line of address"
                                />
                              </Form.Item>
                            </DisabledStyles>
                          </div>

                          <div className="boxFormType">
                            <DisabledStyles>
                              <Form.Item
                                name="shipping_address_line_2"
                                rules={[{}]}
                                className=""
                              >
                                <Input
                                  disabled={
                                    shippedCustAddCheckbox || shippedConsigneeAddCheckbox ||
                                    poFromOrders.state?.cancelChangesDisable
                                  }
                                  className="disabled-check"
                                  placeholder="Second Line of address"
                                />
                              </Form.Item>
                            </DisabledStyles>
                          </div>

                          <Col span={12} className="d-flex">
                            <div className="boxFormType">
                              <DisabledStyles>
                                <Form.Item
                                  name="shipping_country"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                  className=""
                                >
                                  <Select
                                    className="disabled-check"
                                    disabled={
                                      shippedCustAddCheckbox || shippedConsigneeAddCheckbox ||
                                      poFromOrders.state?.cancelChangesDisable
                                    }
                                    suffixIcon={
                                      isShippingCountryDropdownOpen ? (
                                        <DropDownSearchDraw />
                                      ) : (
                                        <DownArrowDraw />
                                      )
                                    }
                                    onChange={handleProvinceChangeForShipping}
                                    onBlur={OnShippingCountryToggleSelect}
                                    onFocus={OnShippingCountryToggleSelect}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    placeholder="Select Country"
                                  >
                                    {Country.getAllCountries().map((province) => (
                                      <Option key={province.isoCode}>
                                        {province.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                            <div className="boxFormType">
                              <DisabledStyles>
                                <Form.Item
                                  name="shipping_state"
                                  className=""
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                >
                                  <Select
                                    disabled={
                                      shippedCustAddCheckbox || shippedConsigneeAddCheckbox ||
                                      poFromOrders.state?.cancelChangesDisable
                                    }
                                    suffixIcon={
                                      isShippingStateDropdownOpen ? (
                                        <DropDownSearchDraw />
                                      ) : (
                                        <DownArrowDraw />
                                      )
                                    }
                                    onBlur={OnShippingStateToggleSelect}
                                    onFocus={OnShippingStateToggleSelect}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    placeholder="Select State"
                                  >
                                    {shippingCities.map((city) => (
                                      <Option key={city.name}>{city.name}</Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                          </Col>
                          <Col span={12} className="d-flex">
                            <div
                              className="boxFormType"
                              style={{ marginBottom: "0" }}
                            >
                              <DisabledStyles>
                                <Form.Item
                                  name="shipping_city"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                  className=""
                                >
                                  <Input
                                    placeholder="City"
                                    disabled={
                                      shippedCustAddCheckbox || shippedConsigneeAddCheckbox ||
                                      poFromOrders.state?.cancelChangesDisable
                                    }
                                    className="disabled-check"
                                    style={{ textTransform: "capitalize" }}
                                  />
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                            <div className="boxFormType">
                              <DisabledStyles>
                                <Form.Item
                                  name="shipping_pincode"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                    { min: 6, message: "Minimum length: 6" },
                                    { max: 6, message: "Maximum length: 6" },
                                    {
                                      pattern: new RegExp(/^[0-9]+$/),
                                      message: "Only Numeric value is possible",
                                    },
                                  ]}
                                  className=""
                                >
                                  <Input
                                    disabled={
                                      shippedCustAddCheckbox || shippedConsigneeAddCheckbox ||
                                      poFromOrders.state?.cancelChangesDisable
                                    }
                                    className="disabled-check"
                                    placeholder="ZIP code"
                                  />
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                          </Col>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>Billing Address</h2>
                        <p>
                          The customer/dealer address where order is to be
                          billed
                        </p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>Building Number and Street Address</label>
                            <p
                              style={{
                                fontSize: "14px",
                                lineHeight: "20px",
                                fontFamily: "var(--sf-pro-display-m)",
                                color: "var(--black-color)",
                                marginBottom: "5px",
                              }}
                            >
                              The complete postal address for billing
                            </p>
                            <div className="checklist-address">
                              <Checkbox
                                type="checkbox"
                                value={billingCustAddCheckbox}
                                checked={billingCustAddCheckbox}
                                onChange={billingAddCustHandler}
                                disabled={!customer}
                              >
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontStyle: "normal",
                                    lineHeight: "20px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--para-text)",
                                    margin: "0",
                                  }}
                                >
                                  This address is same as customer office <br />
                                  address
                                </span>
                              </Checkbox>
                            </div>
                            <div className="checklist-address">
                              <Checkbox
                                type="checkbox"
                                value={billingConsigneeAddCheckbox}
                                checked={billingConsigneeAddCheckbox}
                                onChange={billingAddConsigneeHandler}
                                disabled={!consignee}
                              >
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontStyle: "normal",
                                    lineHeight: "20px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--para-text)",
                                    margin: "0",
                                  }}
                                >
                                  This address is same as consignee office <br />
                                  address
                                </span>
                              </Checkbox>
                            </div>
                          </div>
                        </Col>

                        <Col span={12} className="blockBreak">
                          <div className="boxFormType">
                            <DisabledStyles>
                              <Form.Item
                                name="billing_address_line_1"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                ]}
                                className=""
                              >
                                <Input
                                  disabled={
                                    billingCustAddCheckbox || billingConsigneeAddCheckbox ||
                                    poFromOrders.state?.cancelChangesDisable
                                  }
                                  type="text"
                                  className="disabled-check"
                                  placeholder="First Line of address"
                                />
                              </Form.Item>
                            </DisabledStyles>
                          </div>

                          <div className="boxFormType">
                            <DisabledStyles>
                              <Form.Item
                                name="billing_address_line_2"
                                rules={[{}]}
                                className=""
                              >
                                <Input
                                  disabled={
                                    billingCustAddCheckbox || billingConsigneeAddCheckbox ||
                                    poFromOrders.state?.cancelChangesDisable
                                  }
                                  className="disabled-check"
                                  placeholder="Second Line of address"
                                />
                              </Form.Item>
                            </DisabledStyles>
                          </div>

                          <Col span={12} className="d-flex">
                            <div className="boxFormType">
                              <DisabledStyles>
                                <Form.Item
                                  name="billing_country"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                  className=""
                                >
                                  <Select
                                    className="disabled-check"
                                    disabled={
                                      billingCustAddCheckbox || billingConsigneeAddCheckbox ||
                                      poFromOrders.state?.cancelChangesDisable
                                    }
                                    suffixIcon={
                                      isBillingCountryDropdownOpen ? (
                                        <DropDownSearchDraw />
                                      ) : (
                                        <DownArrowDraw />
                                      )
                                    }
                                    onChange={handleProvinceChangeForBilling}
                                    onBlur={OnBillingCountryToggleSelect}
                                    onFocus={OnBillingCountryToggleSelect}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    placeholder="Select Country"
                                  >
                                    {Country.getAllCountries().map((province) => (
                                      <Option key={province.isoCode}>
                                        {province.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                            <div className="boxFormType">
                              <DisabledStyles>
                                <Form.Item
                                  name="billing_state"
                                  className=""
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                >
                                  <Select
                                    disabled={
                                      billingCustAddCheckbox || billingConsigneeAddCheckbox ||
                                      poFromOrders.state?.cancelChangesDisable
                                    }
                                    suffixIcon={
                                      isBillingStateDropdownOpen ? (
                                        <DropDownSearchDraw />
                                      ) : (
                                        <DownArrowDraw />
                                      )
                                    }
                                    onBlur={OnBillingStateToggleSelect}
                                    onFocus={OnBillingStateToggleSelect}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    placeholder="Select State"
                                  >
                                    {billingCities.map((city) => (
                                      <Option key={city.name}>{city.name}</Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                          </Col>
                          <Col span={12} className="d-flex">
                            <div
                              className="boxFormType"
                              style={{ marginBottom: "0" }}
                            >
                              <DisabledStyles>
                                <Form.Item
                                  name="billing_city"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                  className=""
                                >
                                  <Input
                                    placeholder="City"
                                    disabled={
                                      billingCustAddCheckbox || billingConsigneeAddCheckbox ||
                                      poFromOrders.state?.cancelChangesDisable
                                    }
                                    className="disabled-check"
                                    style={{ textTransform: "capitalize" }}
                                  />
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                            <div className="boxFormType">
                              <DisabledStyles>
                                <Form.Item
                                  name="billing_pincode"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                    { min: 6, message: "Minimum length: 6" },
                                    { max: 6, message: "Maximum length: 6" },
                                    {
                                      pattern: new RegExp(/^[0-9]+$/),
                                      message: "Only Numeric value is possible",
                                    },
                                  ]}
                                  className=""
                                >
                                  <Input
                                    disabled={
                                      billingCustAddCheckbox || billingConsigneeAddCheckbox ||
                                      poFromOrders.state?.cancelChangesDisable
                                    }
                                    className="disabled-check"
                                    placeholder="ZIP code"
                                  />
                                </Form.Item>
                              </DisabledStyles>
                            </div>
                          </Col>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </HaberForm>
                <Row gutter={[16, 16]} className="groupForm lastGroup">
                  <Col span={8}>
                    <GroupTitle>
                      <h2>Other Information</h2>
                      <p>All other information related to this PO</p>
                    </GroupTitle>
                  </Col>
                  <Col span={16}>
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Documents</label>
                            <p
                              style={{
                                fontSize: "14px",
                                lineHeight: "20px",
                                fontFamily: "var(--sf-pro-display-m)",
                                color: "var(--black-color)",
                                marginBottom: "5px",
                                width:"91%"
                              }}
                            >
                              Scanned copies, PDF and other documents related to
                              the POP
                            </p>
                        </div>
                      </Col>
                      <Col span={12} className="blockBreak">
                      {uploadedFileErr?.length ?
                        uploadedFileErr?.map((item, index) => {
                        return (item.err ? (
                          <>
                            {index > 0 ? (
                              <br></br>
                            ) : ""}
                            <span className="errorText" style={{
                              color: "#ea4e2c",
                              marginTop: "-17px",
                              marginBottom: "5px",
                            }}>Invalid file: {item.name}</span>
                          </>) : (""))
                      }) : ""}
                      {uploadedFileErr?.length ? (
                        <>
                          <br></br>
                          <span className="errorText" 
                          style={{
                            color: "#ea4e2c",
                            marginTop: "-17px",
                            marginBottom: "5px"}}>
                            Supported file formats : JPG, JPEG or PDF; Max allowed size : 1 mb</span>
                        </>) : ("")}
                        <div className="boxFormType csv-file" style={{ marginBottom: '0' }}>
                          <Dragger {...fileUploadData} style={{border: "1px dashed #d9d9d9"}}>
                              <p className="ant-upload-drag-icon" style={{marginTop: "11px"}}>
                                <Iconmoon icon="upload-image" size={18} color="#A19F9D" />
                              </p>
                              <p className="ant-upload-text"><span>Click to add</span> or drag and drop</p>
                              <p className="ant-upload-hint" style={{marginBottom: "11px"}}>JPG, JPEG or PDF (max. 1 MB)</p>
                          </Dragger>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {/* add order button */}
                <Row gutter={[16, 16]}>
                <Col span={8}></Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}></Col>
                    <Col span={12} className="blockBreak">
                      <Col span={12} className="d-flex" style={{marginLeft:"-23px"}}>
                        <div className="boxFormType"></div>
                        <div className="boxFormType">
                        <GlobalSet>
                          <Button
                            key="addOrder"
                            className="textTypeBtn textBtnIcon"
                            onClick={handleAddNewOrder}
                            disabled={uploadedFileErr?.length}
                            >
                            <Iconmoon icon="addcircle" size={15} color="#EA655B"/>
                            Add orders to this PO
                          </Button>
                          </GlobalSet>
                          </div>
                      </Col>
                    </Col>
                  </Row>
                  </Col>
                </Row>
              </Form>
            </div>
          {/* </StyledTab> */}
          {/* Cancel changes modal */}
          <ModalPopup visible={isVisibleCancelModal}>
            <div className="Popup-img">
              <img src={warning} alt="Warning" />
            </div>
            <div className="Popup-content">
              <span>Are you sure?</span>
              <p>
                You have pending changes on this page, are you sure you want to
                leave?
              </p>
            </div>
            <div className="ant-modal-footer-section">
              <Button
                key="back"
                className="themeBtn-plane"
                onClick={() => modalCancelClose()}
              >
                <div className="plusPopUpBorder">
                  <Iconmoon
                    icon="plus-sign"
                    size={9}
                    color="#EA655B"
                    className="ant-ico-sec"
                  />
                </div>
                Cancel
              </Button>

              <Button
                key="submit"
                className="themeBtn"
                onClick={() => modalCancelConfirm()}
              >
                <Iconmoon icon="tick-mark" size={14} color="#ffff" />
                Confirm
              </Button>
            </div>
          </ModalPopup>
        {/* </HaberForm> */}
      </DetailFields>

      {/* Toasters*/}
      {visibleToaster && (
        <AlertContainer
          setClose={setVisibleToaster}
          color={actionToaster.error ? "red toaster" : "green toaster"}
          icon={actionToaster.error ? alertRed : alertGreen}
          msg={actionToaster.msg}
          closeIcon={true}
        />
      )}

    {newOrderDrawer && (<MultiDiaAddOrderDrawer
        visible={newOrderDrawer}
        onClose={onCloseAddNewOrder}
        onCloseGrade={onCloseAddNewOrder}
        rendering={setRendering}
        poDetails={poData}
        toasterAction={setActionToaster}
        showToaster={() => showToaster(setVisibleToaster)}
        isOrders={false}
        page="poPage"
      ></MultiDiaAddOrderDrawer>)}

    </RightLayoutContainer>
  );
};

export default AddNewPoData;
